export const environment = {
  version: {
    appVersion: require('../../package.json').version,
    buildNumber: '20260916.1',
    suffix: '-dev',
  },
  production: false,
  msalConfig: {
    auth: {
      clientId: 'd5a11c6b-c46f-4543-9e71-991f110ff194',
      authority: 'https://login.microsoftonline.com/b7be7686-6f97-4db7-9081-a23cf09a96b5',
      redirect: 'https://dev.cemlive-management.ienergy.halliburton.com/'
    }
  },
  msGraphConfig: {
    scopes: ['.default'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },
  backendConfig: {
    scopes: ['api://775fdc00-ab4b-4288-afa5-e21562a63050/WellCatalog'],
    url: 'https://dev.cemlive-management-api.ienergy.halliburton.com/'
  }
};
